import React, { useState } from "react";
import "./index.scss";
import Button from "../../../../components/common/button/index";
import HospitalIndemnityModal from "./modals/hospitalModal";
import ProfessionalIndemnityModal from "./modals/professionalModal";
import { useLocation, useNavigate } from "react-router-dom";
import { setParamsInURL } from "../../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import WarningModal from "../../../../components/warningModal";
import { attribute, profile } from "../../../../utils/router/constant";
import Investigation from "../../../../assets/images/investigation.png";
import {
  setAttributesFormForm,
  setProductAttributesData,
} from "../../../../store/slices/product/productSlice";
import { useEffect } from "react";

const ProductCard = ({
  file_object,
  name,
  product_description,
  media_url,
  type,
  entityid,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isFirstLogin = useSelector((state) => state.common.isFirstLogin);
  const agDetails = useSelector((state) => state.common.agDetails);
  const [show, setShow] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  // const [productid, setProductId] = useState(null);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleModal = () => {
    setShowWarning(!showWarning);
  };

  const viewDetail = async () => {
    dispatch(setAttributesFormForm({}));
    dispatch(setProductAttributesData({}));
    const paramObject = {
      entityid: entityid,
    };
    const params = await setParamsInURL(location, paramObject);
    // profile_enabled false (MSCDA): profile is filled later, before the proposal form
    if (isFirstLogin === 1 && agDetails?.profile_enabled !== false) {
      handleModal();
    } else {
      navigate(`${attribute}?${params}`);
    }
  };

  return (
    <>
      <div className="card indemnity--card">
        <div className="card--img">
          <img src={media_url} height={"50px"} width={"90px"} />
        </div>
        <div className="card--data">
          <h5 className="card-title">{name}</h5>
          <div
            className="card-description"
            title={product_description?.replace(/<[^>]*>?/gm, "")}
            dangerouslySetInnerHTML={{ __html: product_description }}
          />
        </div>
        <div className="card-body--bottom">
          <Button
            type="button"
            variant="primary"
            label="Proceed"
            onClick={() => viewDetail()}
          />
        </div>
      </div>
      {/* {type === "DOCTOR" && ( */}
      {/* <ProfessionalIndemnityModal
        show={show}
        handleClose={handleClose}
        entityid={entityid}
      /> */}
      {/* )} */}
      {/* {type === "HOSPITAL" && ( */}
      {/* <HospitalIndemnityModal
        show={show}
        handleClose={handleClose}
        entityid={entityid}
      /> */}
      {/* )} */}
      <WarningModal
        title="Disclaimer!"
        subtitle="Your Profile is incomplete. Please complete it to avail the service!"
        btnText="Complete your profile"
        onClickHandler={() => navigate(profile)}
        handleModal={handleModal}
        show={showWarning}
        img={Investigation}
      />
    </>
  );
};

export default ProductCard;
